import Navbar from '../../pages/home/components/Navbar';
import Footer from '../../pages/home/components/Footer';
import { INSTAGRAM_PROFILE_URL, WHATSAPP_CHAT_URL } from '../../config/contactLinks';

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="font-sans">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <a
        href={INSTAGRAM_PROFILE_URL}
        target="_blank"
        rel="nofollow noreferrer"
        aria-label="Instagram hesabımıza git"
        className="fixed bottom-[5.5rem] right-6 z-50 flex items-center justify-center w-14 h-14 sm:w-auto sm:h-auto sm:justify-start gap-0 sm:gap-2 bg-[#E4405F] text-white px-0 py-0 sm:px-4 sm:py-3 rounded-full font-bold text-sm cursor-pointer hover:bg-[#d73756] transition-colors whitespace-nowrap"
        style={{ boxShadow: '0 4px 20px rgba(228,64,95,0.35)' }}
      >
        <span className="w-6 h-6 flex items-center justify-center">
          <i className="ri-instagram-line text-xl"></i>
        </span>
        <span className="hidden sm:inline">Instagram</span>
      </a>
      <a
        href={WHATSAPP_CHAT_URL}
        target="_blank"
        rel="nofollow noreferrer"
        aria-label="WhatsApp ile iletişime geç"
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 sm:w-auto sm:h-auto sm:justify-start gap-0 sm:gap-2 bg-[#25D366] text-white px-0 py-0 sm:px-4 sm:py-3 rounded-full font-bold text-sm cursor-pointer hover:bg-[#1db954] transition-colors whitespace-nowrap"
        style={{ boxShadow: '0 4px 20px rgba(37,211,102,0.4)' }}
      >
        <span className="w-6 h-6 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl"></i>
        </span>
        <span className="hidden sm:inline">Teklif Al</span>
      </a>
    </div>
  );
}
